import {axios as http} from "@/plugins/http"

export default class Api {
    static getPost(postId) {
        return http.post("/api/v1/post/mark-ad-auto/get-post", {
            "post_id": postId,
        }).then((resp) => {
            return resp.data
        })
    }
}
